function wp_menu() {
	
	jQuery('li.icon-search').click(function(event) {
		jQuery(this).toggleClass('open-search');
		jQuery('.top-bar-right-top').toggleClass('open-search');
		jQuery('body').toggleClass('open-search-box');
		jQuery('#mobile-menu').foundation('close');
		if(jQuery('a.menu-bt').hasClass('active')) {
			jQuery('a.menu-bt').removeClass('active');
			jQuery('a.menu-bt #hamburger').removeClass('active');
			jQuery('body').removeClass('open-mm');
		}
		event.preventDefault();
	});
}

function wp_menu_mobile() {
	jQuery('a.menu-bt').click(function(event){
		jQuery('body').toggleClass('open-mm');
		jQuery(this).toggleClass('active');
		jQuery('a.menu-bt #hamburger').toggleClass('active');
		jQuery('#search-dropdown-mobile').foundation('close');
		if(jQuery('li.icon-search').hasClass('open-search')) {
			jQuery('li.icon-search').removeClass('open-search');
			jQuery('.top-bar-right-top').removeClass('open-search');
			jQuery('body').removeClass('open-search-box');
		}
		event.preventDefault();
	});
}
